(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxWizardPageValidate', {
		bindings: {
			pageKey: '@',
			sourcePath: '@',
			isValid: '=?',
			message: '=?',
			wizard: '=?',
		},
		controller: MxWizardPageValidateCtrl,
		controllerAs: 'vm',
	});

	MxWizardPageValidateCtrl.$inject = ['$q', '$scope', 'mx.SolutionBuilderAgent.DataModelService'];

	function MxWizardPageValidateCtrl($q, $scope, dataModelService) {
		var vm = this;

		vm.$onInit = function () {
			var widgetId = vm.wizard && vm.wizard.__widgetHtmlData && vm.wizard.__widgetHtmlData.Id;

			if (widgetId && vm.pageKey && vm.sourcePath) {
				var pages = vm.pageKey.split(',');

				pages.forEach(function (page) {
					var wizardPage = getWizardPageByKey(vm.wizard, page);

					if (wizardPage) {
						var button = null;
						if (wizardPage.buttons.next.isVisible) {
							button = wizardPage.buttons.next;
						} else if (wizardPage.buttons.finish.isVisible) {
							button = wizardPage.buttons.finish;
						}

						if (!button) {
							return;
						}

						var newError = null;
						var oldError = null;

						button.validate = function () {
							return dataModelService.reloadSourceByPath(vm.sourcePath, wizardPage.dataModel, widgetId).then(function () {
								var deferred = $q.defer();

								$scope.$applyAsync(function () {
									var errors = vm.wizard.errors ? vm.wizard.errors.slice(0) : [];

									if (!vm.isValid) {
										var oldErrorIndex = errors.indexOf(oldError);

										if (oldErrorIndex !== -1) {
											errors.splice(oldErrorIndex, 1);
										}

										newError = {
											message: vm.message,
											type: 'error',
											active: true,
											transient: true,
										};

										errors.unshift(newError);
										oldError = newError;
									} else {
										var oldErrorIndexNew = errors.indexOf(oldError);

										if (oldErrorIndexNew !== -1) {
											errors.splice(oldErrorIndexNew, 1);
										}
									}
									vm.wizard.errors = errors;
									deferred.resolve(vm.isValid);
								});

								return deferred.promise;
							});
						};
					}
				});
			}
		};

		function getWizardPageByKey(wizard, key) {
			if (!wizard || !key) {
				return null;
			}

			var allPages = wizard.allWizardPages || [];

			for (var i = 0; i < allPages.length; i++) {
				if (allPages[i].key === key) {
					return allPages[i];
				}
			}

			return null;
		}

		return vm;
	}
})();
